import { Component } from '@angular/core';

@Component({
    selector: 'coming-soon-svg',
    templateUrl: '../../../../../../src/assets/svgs/coming-soon.svg',
    styleUrls: ['../svg.component.scss']
})
export class ComingSoonSVG {

}